import type { TFunction } from 'i18next';

import type { GetNarrative200NarrativesItem } from '@/api/generated/lucioAPI.schemas';
import { type NarrativeCardData } from '@/features/narrative/components/NarrativeCard';
import { formatNarrativeTimestamp } from '@/utils/dateUtils';
import { extractNameInitial } from '@/utils/utils';

export function narrativeToCardData(
  narrative: GetNarrative200NarrativesItem,
  t: TFunction,
): NarrativeCardData {
  return {
    content: narrative.summary || '',
    graphMessageId: narrative.graphMessageId,
    id: narrative.id,
    senderColor: 'bg-info',
    senderInitial: extractNameInitial(narrative.fromName),
    senderName: narrative.fromName || t('narrative.unknownSender'),
    subject: narrative.emailSubject || t('narrative.noSubject'),
    timestamp: formatNarrativeTimestamp(narrative.sentAt),
  };
}
